import { render, staticRenderFns } from "./ProductSkeleton.vue?vue&type=template&id=5e9992c9&"
import script from "./ProductSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProductSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports